var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useEffect, useMemo, useState } from 'react';
import { Button, Divider, Form, Input, Modal, Select, Switch, Upload } from 'antd';
import { buildInsertPositionOptions, defaultInsertPositionValue } from './insert-position-options';
const buildUploadFileList = file => file ? [{
        uid: '-1',
        name: file.name,
        status: 'done'
    }] : [];
function RankLevelImageUpload({ editingLevel, selectedImageFile, imageUploadFileList, onSelectFile, onRemoveFile }) {
    return /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u30A2\u30A4\u30B3\u30F3\u753B\u50CF",
        name: "image"
    }, /*#__PURE__*/ React.createElement(Upload, {
        beforeUpload: file => {
            onSelectFile(file);
            return false;
        },
        onRemove: () => {
            onRemoveFile();
        },
        fileList: imageUploadFileList,
        maxCount: 1,
        accept: "image/*"
    }, /*#__PURE__*/ React.createElement(Button, null, "\u753B\u50CF\u3092\u9078\u629E")), (editingLevel === null || editingLevel === void 0 ? void 0 : editingLevel.image_url) && !selectedImageFile ? /*#__PURE__*/ React.createElement("img", {
        src: editingLevel.image_url,
        alt: `${editingLevel.code} rank icon`,
        className: "mt-3 h-[80px] w-[80px] rounded-lg border border-[#e5e7eb] object-cover"
    }) : null);
}
export default function RankingLevelFormModal({ open, mode, editingLevel, existingLevels = [], loading = false, onCancel, onSubmit }) {
    var _a;
    const _Form$useForm = Form.useForm(), _Form$useForm2 = _slicedToArray(_Form$useForm, 1), form = _Form$useForm2[0];
    const _useState = useState(null), _useState2 = _slicedToArray(_useState, 2), selectedImageFile = _useState2[0], setSelectedImageFile = _useState2[1];
    const isCreate = mode === 'create';
    const insertPositionOptions = useMemo(() => buildInsertPositionOptions(existingLevels), [existingLevels]);
    useEffect(() => {
        var _a, _b;
        if (!open)
            return;
        if (isCreate) {
            form.setFieldsValue({
                code: '',
                name: '',
                insert_position: defaultInsertPositionValue(existingLevels),
                description: '',
                active: true,
                requires_sti_before_rank_up: false
            });
            form.setFieldValue('image', undefined);
            setSelectedImageFile(null);
            return;
        }
        if (!editingLevel)
            return;
        form.setFieldsValue({
            code: editingLevel.code,
            name: editingLevel.name || '',
            description: editingLevel.description || '',
            active: (_a = editingLevel.active) !== null && _a !== void 0 ? _a : true,
            requires_sti_before_rank_up: (_b = editingLevel.requires_sti_before_rank_up) !== null && _b !== void 0 ? _b : false
        });
        form.setFieldValue('image', undefined);
        setSelectedImageFile(null);
    }, [open, isCreate, editingLevel, existingLevels, form]);
    const imageUploadFileList = useMemo(() => buildUploadFileList(selectedImageFile), [selectedImageFile]);
    const handleOk = () => __awaiter(this, void 0, void 0, function* () {
        var _a;
        const values = yield form.validateFields();
        if (isCreate) {
            yield onSubmit({
                code: values.code.toUpperCase(),
                name: values.name,
                insert_position: values.insert_position,
                description: values.description || '',
                active: values.active,
                image: selectedImageFile || undefined,
                requires_sti_before_rank_up: values.requires_sti_before_rank_up
            }, {
                isCreate: true
            });
            return;
        }
        yield onSubmit({
            code: (_a = values.code) === null || _a === void 0 ? void 0 : _a.toUpperCase(),
            name: values.name,
            description: values.description || '',
            active: values.active,
            image: selectedImageFile || undefined,
            requires_sti_before_rank_up: values.requires_sti_before_rank_up
        }, {
            isCreate: false
        });
    });
    const handleClose = () => {
        form.resetFields();
        form.setFieldValue('image', undefined);
        setSelectedImageFile(null);
        onCancel();
    };
    const handleSelectImage = file => {
        form.setFieldValue('image', file.name);
        setSelectedImageFile(file);
    };
    const handleRemoveImage = () => {
        form.setFieldValue('image', undefined);
        setSelectedImageFile(null);
    };
    return /*#__PURE__*/ React.createElement(Modal, {
        open: open,
        title: isCreate ? 'ランク追加' : `ランク編集 (${(_a = editingLevel === null || editingLevel === void 0 ? void 0 : editingLevel.code) !== null && _a !== void 0 ? _a : ''})`,
        onCancel: handleClose,
        onOk: handleOk,
        okText: isCreate ? '作成' : '更新',
        cancelText: "\u30AD\u30E3\u30F3\u30BB\u30EB",
        confirmLoading: loading,
        destroyOnHidden: true,
        width: 640
    }, /*#__PURE__*/ React.createElement(Form, {
        form: form,
        layout: "vertical"
    }, isCreate ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u30B3\u30FC\u30C9",
        name: "code",
        rules: [{
                required: true,
                message: 'コードを入力してください'
            }, {
                pattern: /^[A-Z0-9+]+$/,
                message: '英大文字・数字・+ のみ'
            }]
    }, /*#__PURE__*/ React.createElement(Input, {
        placeholder: "B+"
    })), /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u30E9\u30F3\u30AF\u540D",
        name: "name",
        rules: [{
                required: true,
                message: 'ランク名を入力してください'
            }]
    }, /*#__PURE__*/ React.createElement(Input, {
        placeholder: "B+ Rank"
    })), /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u633F\u5165\u4F4D\u7F6E",
        name: "insert_position",
        rules: [{
                required: true,
                message: '挿入位置を選択してください'
            }],
        extra: "\u4F8B: \u300CA \u3068 B \u306E\u9593\u300D\u2192 \u30E6\u30FC\u30B6\u30FC\u306F B \u306E\u6B21\u306B B+ \u3092\u76EE\u6307\u3057\u307E\u3059"
    }, /*#__PURE__*/ React.createElement(Select, {
        options: insertPositionOptions
    })), /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u8AAC\u660E",
        name: "description"
    }, /*#__PURE__*/ React.createElement(Input.TextArea, {
        rows: 3,
        placeholder: "\u30E9\u30F3\u30AF\u306E\u8AAC\u660E"
    })), /*#__PURE__*/ React.createElement(RankLevelImageUpload, {
        editingLevel: null,
        selectedImageFile: selectedImageFile,
        imageUploadFileList: imageUploadFileList,
        onSelectFile: handleSelectImage,
        onRemoveFile: handleRemoveImage
    }), /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u30B9\u30C6\u30FC\u30BF\u30B9",
        name: "active",
        valuePropName: "checked"
    }, /*#__PURE__*/ React.createElement(Switch, null)), /*#__PURE__*/ React.createElement(Form.Item, {
        label: "STI\u5FC5\u9808\uFF08\u3053\u306E\u30E9\u30F3\u30AF\u3078\u306E\u7533\u8ACB\u524D\uFF09",
        name: "requires_sti_before_rank_up",
        valuePropName: "checked"
    }, /*#__PURE__*/ React.createElement(Switch, null))) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Divider, {
        orientation: "left",
        plain: true
    }, "\u57FA\u672C\u60C5\u5831"), /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u30B3\u30FC\u30C9",
        name: "code"
    }, /*#__PURE__*/ React.createElement(Input, {
        disabled: true
    })), /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u30B9\u30C6\u30FC\u30BF\u30B9",
        name: "active",
        valuePropName: "checked"
    }, /*#__PURE__*/ React.createElement(Switch, null)), /*#__PURE__*/ React.createElement(Divider, {
        orientation: "left",
        plain: true
    }, "\u8868\u793A"), /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u30E9\u30F3\u30AF\u540D",
        name: "name",
        rules: [{
                required: true,
                message: 'ランク名を入力してください'
            }]
    }, /*#__PURE__*/ React.createElement(Input, {
        placeholder: "B+ Rank"
    })), /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u8AAC\u660E",
        name: "description"
    }, /*#__PURE__*/ React.createElement(Input.TextArea, {
        rows: 3,
        placeholder: "\u30E9\u30F3\u30AF\u306E\u8AAC\u660E"
    })), /*#__PURE__*/ React.createElement(RankLevelImageUpload, {
        editingLevel: editingLevel,
        selectedImageFile: selectedImageFile,
        imageUploadFileList: imageUploadFileList,
        onSelectFile: handleSelectImage,
        onRemoveFile: handleRemoveImage
    }), /*#__PURE__*/ React.createElement(Divider, {
        orientation: "left",
        plain: true
    }, "\u30E9\u30F3\u30AF\u30A2\u30C3\u30D7\u8A2D\u5B9A"), /*#__PURE__*/ React.createElement(Form.Item, {
        label: "STI\u5FC5\u9808\uFF08\u3053\u306E\u30E9\u30F3\u30AF\u3078\u306E\u7533\u8ACB\u524D\uFF09",
        name: "requires_sti_before_rank_up",
        valuePropName: "checked"
    }, /*#__PURE__*/ React.createElement(Switch, null)))));
}
